/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./detail-tab.vue?vue&type=template&id=22d682c6&scoped=true&"
import script from "./detail-tab.vue?vue&type=script&lang=ts&"
export * from "./detail-tab.vue?vue&type=script&lang=ts&"
import style0 from "./detail-tab.vue?vue&type=style&index=0&id=22d682c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d682c6",
  null
  
)

export default component.exports